import api from './api';

const weworkGroupWelcomeTemplateService = {
  list: async (params = {}) => {
    const res = await api.get('/wework/group-welcome-templates', { params });
    return res.data;
  },
  getById: async (id, params = {}) => {
    const res = await api.get(`/wework/group-welcome-templates/${id}`, { params });
    return res.data;
  },
  create: async (data, params = {}) => {
    const res = await api.post('/wework/group-welcome-templates', data, { params });
    return res.data;
  },
  update: async (id, data, params = {}) => {
    const res = await api.put(`/wework/group-welcome-templates/${id}`, data, { params });
    return res.data;
  },
  remove: async (id, params = {}) => {
    const res = await api.delete(`/wework/group-welcome-templates/${id}`, { params });
    return res.data;
  }
};

export default weworkGroupWelcomeTemplateService;


